// Design System Web 3.0, introduced in October 2023
import breakpoints from './breakpoints';

const mobileMaxBreakpointQuery = `@media (max-width: ${breakpoints.values.md - 1}px)`;

const typography = {
  htmlFontSize: 16,
  h1: {
    fontSize: '48px',
    fontFamily: 'MatterLight, Arial, sans-serif',
    fontWeight: 300,
    lineHeight: '110%',
    letterSpacing: 0,
    [mobileMaxBreakpointQuery]: {
      fontSize: '34px',
    },
    hero: {
      fontSize: '64px',
      lineHeight: 1.109375,
      [mobileMaxBreakpointQuery]: {
        fontSize: '48px',
        lineHeight: 1.104167,
      },
    },
  },
  h2: {
    fontSize: '40px',
    fontFamily: 'MatterLight, Arial, sans-serif',
    lineHeight: '110%',
    [mobileMaxBreakpointQuery]: {
      fontSize: '30px',
    },
  },
  h3: {
    fontSize: '32px',
    fontFamily: 'MatterLight, Arial, sans-serif',
    lineHeight: '110%',
    [mobileMaxBreakpointQuery]: {
      fontSize: '26px',
    },
  },
  h4: {
    fontSize: '22px',
    fontFamily: 'MatterRegular, Arial, sans-serif',
    lineHeight: '110%',
    [mobileMaxBreakpointQuery]: {
      fontSize: '18px',
    },
  },
  h5: {
    fontSize: '25px',
    fontFamily: 'MatterRegular, Arial, sans-serif',
    lineHeight: '110%',
    [mobileMaxBreakpointQuery]: {
      fontSize: '22px',
    },
  },
  h6: {
    fontSize: '18px',
    fontFamily: 'MatterRegular, Arial, sans-serif',
    lineHeight: '110%',
    [mobileMaxBreakpointQuery]: {
      fontSize: '18px',
      lineHeight: '115%',
    },
  },
  body: {
    fontSize: '18px',
    fontFamily: 'MatterRegular, Arial, sans-serif',
    lineHeight: '110%',
    [mobileMaxBreakpointQuery]: {
      fontSize: '17px',
    },
  },
  buttonLabel: {
    fontSize: '15px',
    fontFamily: 'MatterMedium, Arial, sans-serif',
    lineHeight: '110%',
  },
  bodySM: {
    fontFamily: 'MatterRegular, Arial, sans-serif',
    fontSize: '14px',
    lineHeight: 1.285714,
  },
  small: {
    fontFamily: 'MatterRegular, Arial, sans-serif',
    fontSize: '14px',
    lineHeight: 1.285714,
  },
  smallXS: {
    fontFamily: 'MatterMedium, Arial, sans-serif',
    fontSize: '10px',
    lineHeight: '115%',
    [mobileMaxBreakpointQuery]: {
      fontSize: '12px',
    },
  },
  useNextVariants: true,
};
export default typography;
